import React from 'react'

import { Formik } from 'formik'

import { Form, Modal, Button } from '_zari/core'
import Yup from '_zari/validation/_yup'

import * as FormGroups from './formGroups'
import * as Sections from '../_shared/sections'

export const ValidationSchema = Yup.object().shape({
  tipoMovimientoActivo: Yup.string().required(),
  _idActivoFijo: Yup.string().required()
})

const ActivoDepreciacionModal = ({ show, handleClose, modalData, submitFunction, esAvanzado }) => {
  const formInitialValues = React.useMemo(() => {
    return {
      ...modalData,
      _idActivoFijo: modalData._idActivoFijo || '',
      tipoMovimientoActivo: modalData.tipoMovimientoActivo || '2'
    }
  }, [modalData])

  const onSubmit = React.useCallback(
    data => {
      submitFunction({
        ...data,
        modalValido: true
      })
    },
    [submitFunction]
  )

  return (
    <Modal show={show} centered size='sm'>
      <Modal.Header>
        <Modal.Title>{esAvanzado ? 'EDICION AVANZADA' : 'ACTIVOS FIJOS - DEPRECIACION'}</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={onSubmit} validationSchema={ValidationSchema}>
        {({ errors, touched, isSubmitting, values, handleSubmit, handleChange, setFieldValue, setValues }) => (
          <>
            <Modal.Body>
              <Form>
                {esAvanzado && (
                  <Sections.ComunSection
                    errors={errors}
                    touched={touched}
                    isSubmitting={isSubmitting}
                    handleChange={handleChange}
                    values={values}
                    setFieldValue={setFieldValue}
                    setValues={setValues}
                    nextNodeId='select-tipoMovimientoActivo'
                  />
                )}
                <FormGroups.ActivoFijoFormGroup
                  iValue={values._idActivoFijo}
                  iError={errors._idActivoFijo}
                  iTouched={touched._idActivoFijo}
                  fIsSubmitting={isSubmitting}
                  handleChange={handleChange}
                  iCuentaContable={modalData.cuentaContable}
                  setFieldValue={setFieldValue}
                />
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose} disabled={isSubmitting}>
                Cancelar
              </Button>
              <Button id='button-ActivoDepreciacionmodal-procesar' onClick={handleSubmit} disabled={isSubmitting}>
                Guardar
              </Button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(ActivoDepreciacionModal)
